import frustumCull from '../frustumCull'
import hsv_rgb from '../hsv_rgb'
import noise3D from '../noise3D'

export default `${noise3D + hsv_rgb}
uniform vec3 uColor1;
uniform vec3 uColor2;

uniform vec3 uBgColor;
uniform vec3 uInnerShadowColor;
uniform vec4 uRectData;
uniform vec4 uProgress;
uniform vec3 uRandom;
uniform mat3 normalMatrix;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vPosition;
varying vec3 vWorldPosition;

void main(){

  vec3 color = uColor2;

  float alpha = 1.0;
  #ifndef IS_GLASS_RENDER
  ${frustumCull}
  #endif

  vec3 p = vPosition * 0.5 + 0.5;

  float gradientFactor = p.x + 1.0 - p.y;
  gradientFactor = pow(gradientFactor, 2.0);

  color = mix(uColor1, uColor2, p.z);
  alpha = gradientFactor * 0.2;


  #ifdef MOSAIC
    vec3 no = abs(vNormal);
    // Find which component is largest and create one-hot vector
    float maxComponent = max(no.x, max(no.y, no.z));
    no = vec3(equal(no, vec3(maxComponent)));

    vec3 no2 = normalize(normalMatrix * (no * sign(vNormal)));

    vec3 pos = floor((vPosition) * 4.0 + 0.5);
    float n = noise(pos + no + vec3(0.5, 1.0, 0.5) * -uProgress.z * 2.0);
    n = step(0.5, n);

    alpha *= mix(1.0, 1.5, n);
  #endif

  #ifdef RAINBOW
    vec3 rainbowFactor = vec3(
      snoise(vec3(vPosition * 0.75 + vec3(0.0, uProgress.y, 0.0))),
      snoise(vec3(vPosition * 0.75 + vec3(5.2) - vec3(0.0, uProgress.y, 0.0))),
      snoise(vec3(vPosition * 0.3 + vec3(10.4) - vec3(0.0, uProgress.y * 0.2, 0.0)))
    ) * 0.5 + 0.5;

    vec3 rainbowColor = uColor1;
    vec3 hsv = rgb2hsv(rainbowColor);
    hsv.r -= rainbowFactor.x * 0.18;
    hsv.g += rainbowFactor.y * 0.1 - uProgress.w * 0.2;
    hsv.b += rainbowFactor.y * 0.2;

    rainbowColor = hsv2rgb(hsv);
    color.rgb = rainbowColor;
    alpha = mix(alpha, 1.0, rainbowFactor.z);
  #endif

  alpha *= mix(1.0, 1.3, uProgress.w);

  gl_FragColor = vec4(color, alpha);

  gl_FragColor.rgb = pow(gl_FragColor.rgb, vec3(1.0/2.2));
}
`
